import React, { useEffect } from "react";
import OrderConfirmation from "../components/panier/OrderConfirmation";
export default function OrderConfirmationPaiement({
  total,
  codeP,
  setCodeP,
  acces,
}) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <OrderConfirmation
      acces={acces}
      total={total}
      codeP={codeP}
      setCodeP={setCodeP}
    />
  );
}
